import { Checkbox, TextBox } from "@progress/kendo-react-inputs";
import { useLocalization } from "@progress/kendo-react-intl";
import { TabStrip, TabStripSelectEventArguments, TabStripTab } from "@progress/kendo-react-layout";
import axios from "axios";
import { useEffect, useState } from "react";
import { AccessToken } from "../../../config/AccessToken";
import { arrowRotateCwIcon, saveIcon } from "@progress/kendo-svg-icons";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { loadingPanel } from "../../LoadingPanel";
import { NotificationGroup, Notification } from "@progress/kendo-react-notification";
import { Fade } from "@progress/kendo-react-animation";
import { Button } from "@progress/kendo-react-buttons";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { isBooleanOption } from "./booleanOptions";

export const ConfigLocatorServer = () => {

    const localizationService = useLocalization();
    let languageId = localStorage.getItem('languageId');
    const SERVER_URL = process.env.REACT_APP_SERVER_URL;
    const [instance, accessTokenRequest] = AccessToken();

    const [selected, setSelected] = useState<number>(0);

    const [tabList, setTabList] = useState<any>([]);
    const [newTabList, setNewTabList] = useState<any>([]);
    const [tabNameList, setTabNameList] = useState<any>([]);

    const [loading, setLoading] = useState(false);
    const [updated, setUpdated] = useState(false);

    const handleSelect = (e: TabStripSelectEventArguments) => {
        setSelected(e.selected);
    };

    useEffect(() => {
        getTabList();
    }, [])

    const getTabList = async () => {

        setLoading(true);

        let languageId = localStorage.getItem('languageId');

        const commonOperations = async (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };

            try {
                const res = await axios.get(`${SERVER_URL}/settings/Server`, { headers })

                const data = res.data

                let tabList: any = [];
                let tabNameList: any = [];
                let tabIdList: any = [];
                let tabDescriptionList: any = [];
                let tabValueList: any = [];
                data.data.forEach((tab: any) => {
                    if (!tabNameList.includes(tab.group)) {
                        tabNameList.push(tab.group)
                    }
                    tabList.push(tab)
                    tabIdList.push({ id: tab.id })
                    tabDescriptionList.push(tab.description)
                    tabValueList.push({ value: tab.value })
                })
                setTabList(tabList)
                setTabNameList(tabNameList)

                setLoading(false);

            } catch (error: any) {
                //setError(error);  
                setLoading(false);
            }
        }
        if (localStorage.getItem('accessToken') != null) {
            let accessToken = localStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then(async (accessTokenResponse: any) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken)
            })
        }
    }

    const handleChangeTextbox = (e: any, index: any) => {
        let currTabList: any = newTabList != '' ? newTabList : tabList;
        const value: any = e.target.value
        currTabList = currTabList.map((element: any) => {
            if (element.id == index) {
                return { ...element, value: value }
            } else {
                return element
            }
        });
        setNewTabList(currTabList);
    };

    const handleChange = (e: any, index: any) => {
        let currTabList: any = newTabList != '' ? newTabList : tabList;
        const value: any = e.target.value == true ? "1" : "0"
        currTabList = currTabList.map((element: any) => {
            if (element.id == index) {
                return { ...element, value: value }
            } else {
                return element
            }
        });
        setNewTabList(currTabList);
    };

    const mixModeOptions = [
        { value: "0", text: "BASIC" },
        { value: "1", text: "PICK_HEAVIEST" },
        { value: "2", text: "MIX_WITH_WEIGHTS" },
        { value: "3", text: "MIX_WITH_WEIGHTS_AND_QUANTITIES" }
    ];

    const handleChangeMixMode = (e: any, index: any) => {
        let currTabList: any = newTabList != '' ? newTabList : tabList;
        const value = e.target.value?.value ?? "0";
        currTabList = currTabList.map((element: any) => {
            if (element.id == index) {
                return { ...element, value };
            } else {
                return element;
            }
        });
        setNewTabList(currTabList);
    };

    const saveGeneralsParams = async () => {

        // Scroll alla cima della pagina PRIMA di tutto
        const scrollToTop = () => {
            // Scroll della window
            window.scrollTo(0, 0);
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
            // Scroll di tutti i possibili contenitori con classe o attributi comuni
            const scrollableElements = document.querySelectorAll('[class*="container"], [class*="content"], [class*="main"], .k-content, .k-tabstrip-content');
            scrollableElements.forEach((element: any) => {
                if (element.scrollTop !== undefined) {
                    element.scrollTop = 0;
                }
            });
        };

        scrollToTop();

        setLoading(true);

        document.documentElement.style.setProperty('--overflow-y-container', 'hidden');
        document.documentElement.style.setProperty('--content-position-loading', 'fixed');

        const params = {
            settings: newTabList
        }


        const commonOperations = async (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            try {
                await axios.put(`${SERVER_URL}/settings/Server`, params, { headers })

                setNewTabList(newTabList);
                setUpdated(true);

                setTimeout(() => {
                    setUpdated(false);
                }, 3000);
                setLoading(false);

                document.documentElement.style.removeProperty('--overflow-y-container');
                document.documentElement.style.removeProperty('--content-position-loading');
            } catch (error: any) {
                //setError(error?.message);
                setLoading(false);
            }
        }

        if (localStorage.getItem('accessToken') != null) {
            let accessToken = localStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken);
            })
                .catch((error: any) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                });
        }

    }

    const resetGeneralsParams = () => {
        window.location.reload();
        getTabList()
    }

    return (
        <div className="locator-collector-page">
            {loading && loadingPanel}

            <NotificationGroup
                style={{
                    right: 0,
                    bottom: 50,
                    alignItems: "flex-start",
                    flexWrap: "wrap-reverse",
                }}
            >
                <Fade enter={true} exit={true}>
                    {updated && (
                        <Notification
                            type={{ style: "success", icon: true }}
                            closable={true}
                            onClose={() => setUpdated(false)}
                        >
                            <span>{localizationService.toLanguageString('configuration.locator.updated', 'NOT FOUND')}</span>
                        </Notification>
                    )}
                </Fade>
            </NotificationGroup>

            <TabStrip
                className="locator-collector-tabstrip"
                selected={selected}
                onSelect={handleSelect}
                tabPosition="left"
                style={{ background: "#F7F7F7" }}
            >
                {
                    tabNameList?.map((tabName: any, index: any) => {
                        let currTabList: any = newTabList != '' ? newTabList : tabList;
                        return (
                            <TabStripTab title={tabName} key={index}>
                                <div className="collector-settings-grid">
                                    {
                                        currTabList
                                            ?.filter((tab: any) => tab.group == tabName)
                                            .map((tab: any) => {
                                                if (tab.id.includes('PositionMixMode') || tab.id.includes('ElevationMixMode')) {
                                                    return (
                                                        <div className="collector-setting-item" key={`${tabName}-${tab.id}`}>
                                                            <div className="collector-setting-label">{tab.id}</div>
                                                            <DropDownList
                                                                id={tab.id}
                                                                data={mixModeOptions}
                                                                textField="text"
                                                                dataItemKey="value"
                                                                size="small"
                                                                style={{ fontSize: '12px' }}
                                                                defaultValue={mixModeOptions.find((option) => option.value === String(tab.value)) ?? mixModeOptions[0]}
                                                                onChange={(event: any) => handleChangeMixMode(event, tab.id)}
                                                            />
                                                        </div>
                                                    )
                                                }

                                                if (!isBooleanOption(tab.id)) {
                                                    return (
                                                        <div className="collector-setting-item" key={`${tabName}-${tab.id}`}>
                                                            <div className="collector-setting-label">{tab.id}</div>
                                                            <TextBox
                                                                id={tab.id}
                                                                defaultValue={tab.value}
                                                                size="small"
                                                                onChange={(event: any) => handleChangeTextbox(event, tab.id)}
                                                                title={tab.description}
                                                                placeholder={tab.description}
                                                            />
                                                        </div>
                                                    )
                                                }

                                                return (
                                                    <div className="collector-setting-item collector-setting-item-checkbox" key={`${tabName}-${tab.id}`}>
                                                        <Checkbox
                                                            label={tab.id}
                                                            defaultChecked={tab.value == 0 ? false : true}
                                                            onChange={(event: any) => handleChange(event, tab.id)}
                                                        />
                                                    </div>
                                                )
                                            })
                                    }
                                </div>
                            </TabStripTab>
                        )
                    })
                }
            </TabStrip>

            <div className="k-listview-item row collector-actions-row" style={{ alignItems: 'baseline' }}>
                <Button
                    className="save-devices-management-button"
                    style={{
                        marginRight: '20px',
                    }}
                    themeColor={"primary"}
                    svgIcon={arrowRotateCwIcon}
                    onClick={() => resetGeneralsParams()}
                >
                    {localizationService.toLanguageString('configuration.locator.locator_client.reset', 'NOT_FOUND')}
                </Button>

                <Button
                    className="save-devices-management-button"
                    disabled={newTabList?.length == 0 ? true : false}
                    themeColor={"primary"}
                    svgIcon={saveIcon}
                    onClick={() => saveGeneralsParams()}
                >
                    {localizationService.toLanguageString('configuration.locator.locator_client.save', 'NOT_FOUND')}
                </Button>

            </div>
        </div>
    )
}